import { useState } from 'react';
import { Button, Card, Icon, Typography } from '@uigovpe/components';
import { CertificateRequest } from '@/shared/types/certificate-request';

interface SubmittedStepProps {
  request: CertificateRequest;
  onTrack: () => void;
  onBackHome: () => void;
}

export function SubmittedStep({ request, onTrack, onBackHome }: SubmittedStepProps) {
  const [copied, setCopied] = useState(false);
  const protocol = request.protocol ?? '';

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(protocol);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch {
      setCopied(false);
    }
  };

  return (
    <section className="cd-step cd-submitted">
      <span className="cd-submitted__icon" aria-hidden>
        <Icon icon="check_circle" />
      </span>

      <Typography variant="h2" size="xl" fontWeight="bold" textAlign="center">
        Solicitação enviada
      </Typography>
      <Typography variant="p" size="default" textAlign="center" className="cd-step__hint">
        Guarde o número do protocolo. Enviamos uma cópia para o seu e-mail e
        avisamos a cada atualização.
      </Typography>

      <Card className="cd-submitted__card">
        <Typography variant="span" size="sm" className="cd-submitted__label">
          Número do protocolo
        </Typography>
        <Typography variant="p" size="xl" fontWeight="bold" className="cd-submitted__protocol">
          {protocol}
        </Typography>
        <Button
          label={copied ? 'Copiado' : 'Copiar número'}
          icon={copied ? 'pi pi-check' : 'pi pi-copy'}
          outlined
          onClick={copy}
        />
      </Card>

      <Typography variant="p" size="sm" textAlign="center" className="cd-step__hint">
        A equipe do Corpo de Bombeiros vai analisar o pedido e entrar em contato
        pelos dados que você informou para concluir a emissão da certidão.
      </Typography>

      <div className="cd-actions">
        <Button label="Voltar ao início" outlined onClick={onBackHome} />
        <Button
          label="Acompanhar solicitação"
          icon="pi pi-arrow-right"
          iconPos="right"
          onClick={onTrack}
        />
      </div>
    </section>
  );
}
